/*
 * 1. 获取用户登录情况
 * 2. 登录获取userid
 * 3. 获取sessionid或者设备id
 * 4. 获取推荐信息
 */
import util from '../utils/util';
import { AutohomeEnvironment } from './environment';
/**
 * 获取设备信息
 * @returns
 */
function getAppDeviceInfo() {
  let deviceId = util.getCookie('app_deviceid') || '';
  if (util.browser.isApp) {
    return new AutohomeEnvironment()
      .getDeviceinfo()
      .then(function (result) {
        deviceId = result.deviceid || deviceId;
        let personalizedPush = false;
        if (
          typeof result.personalizedPush !== 'undefined' &&
          result.personalizedPush !== null
        ) {
          personalizedPush = result.personalizedPush;
        }
        console.error('AppDeviceid', deviceId, personalizedPush);
        return Promise.resolve({ deviceId, personalizedPush });
      })
      .catch(function () {
        return Promise.resolve({ deviceId, personalizedPush: false });
      });
  } else {
    return Promise.resolve({ deviceId, personalizedPush: true });
  }
}
/**
 * 获取客户端唯一标识
 */
class ClientIdentityService {
  constructor() {
    this.promise = null;
  }
  getClientId() {
    if (this.promise) {
      return this.promise;
    }
    this.promise = getAppDeviceInfo();
    return this.promise;
  }
}
const clientIdentityService = new ClientIdentityService();

export { clientIdentityService, ClientIdentityService };
